import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 4V9H2V2H9V4H4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 4V9H22V2H15V4H20Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 15V20H9V22H2V15H4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 20V15H22V22H15V20H20Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 7C13.6569 7 15 8.34315 15 10C15 11.1842 14.3139 12.2081 13.3175 12.696C15.16 13.2593 16.5 14.9731 16.5 17L16.5 17.9972H7.5L7.5 17C7.5 14.9731 8.84003 13.2593 10.6825 12.696C9.6861 12.2081 9 11.1842 9 10C9 8.34315 10.3431 7 12 7Z"}}]};

const PortraitFilled = Vue.extend<IconProps>({
  name: 'PortraitFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'portrait-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PortraitFilled;
